import PropTypes from 'prop-types';
import logoAdss from 'brilliant-travels/images/gift-card-logos/adss.svg';
import logoCcc from 'brilliant-travels/images/gift-card-logos/ccc.svg';
import logoFraserTours from 'brilliant-travels/images/gift-card-logos/frasertours.svg';
import logoMp from 'brilliant-travels/images/gift-card-logos/mp.svg';
import logoSealink from 'brilliant-travels/images/gift-card-logos/sealink.svg';
import logoStarshipSydney from 'brilliant-travels/images/gift-card-logos/starshipsydney.svg';
import logoSvTours from 'brilliant-travels/images/gift-card-logos/svtours.svg';
import logoTheJackson from 'brilliant-travels/images/gift-card-logos/thejackson.svg';
import parse from 'html-react-parser';
import { price as priceFormatter } from 'utils/helpers/helpers';

const logoMap = {
  adss: logoAdss,
  cccsyd: logoCcc,
  cccwa: logoCcc,
  frasertours: logoFraserTours,
  mp: logoMp,
  sealink: logoSealink,
  starshipsydney: logoStarshipSydney,
  svtours: logoSvTours,
  thejackson: logoTheJackson,
};

export default function Card({
  link,
  bgImage,
  title,
  bodyText,
  fromPrice,
  price,
  priceDefinition,
  footerText,
  tenant,
}) {
  const tenantLogo = logoMap[tenant];
  let priceText = '';

  if (price) {
    const formattedPrice = priceFormatter(price, {
      fromCents: false,
      omitZeroCents: true,
    });

    priceText = `${fromPrice ? 'From' : ''} ${formattedPrice} ${
      priceDefinition || ''
    }`;
  }

  return (
    <div className="card h-100 card-animate">
      <div
        className="card-top responsive-square"
        style={{
          backgroundImage: `url(${bgImage})`,
        }}
      >
        <div className="card-heading-wrapper">
          <h4 className="card-heading">
            <span>{title}</span>
          </h4>
        </div>
      </div>
      <div className="card-body">
        <div className="card-text line-clamp-2">{parse(bodyText)}</div>
      </div>
      {priceText && <h5 className="px-3 fw-bold text-primary">{priceText}</h5>}
      <div className="card-footer d-flex align-items-center justify-content-between">
        <div className="card-link-text-wrapper">
          <span className="card-link-text">{footerText}</span>
        </div>
        {tenantLogo && <img className="w-auto" src={tenantLogo} alt={tenant} />}
      </div>
      <a
        className="stretched-link"
        href={link}
        target="_blank"
        title={title}
        rel="noreferrer"
      />
    </div>
  );
}

Card.propTypes = {
  link: PropTypes.string.isRequired,
  bgImage: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  bodyText: PropTypes.string.isRequired,
  fromPrice: PropTypes.bool,
  price: PropTypes.number,
  priceDefinition: PropTypes.string,
  footerText: PropTypes.string.isRequired,
  tenant: PropTypes.string,
};
